import { Injectable, Injector } from '@angular/core';
import { Namespace } from 'enums-lib';
import { Observable } from 'rxjs';
import { BullhornDocumentTypeService } from './bullhorn.document-type.service';
import { IDocumentType } from './document-type-picker.component';
import { InveniasDocumentTypeService } from './invenias.document-type.service';
import { SalesforceDocumentTypeService } from './salesforce.document-type.service';

export const BLANK_TYPE: IDocumentType = {
  id: 'kp-blank',
  label: '- No type specified -',
};

export enum FilterLabel {
  FILE = 'File',
  NOTE = 'Note',
}

export interface IDocumentTypeService {
  getDocumentTypeLabel(): string;
  getDocumentTypes(entityType: string, filterLabel?: FilterLabel): Observable<IDocumentType[]>;
  getRecordTerm(): string;
}

@Injectable({ providedIn: 'root' })
export class DocumentTypeServiceFactory {
  constructor(private injector: Injector) {}

  getService(namespace: string | Namespace): IDocumentTypeService {
    if (namespace === Namespace.invenias) {
      return this.injector.get(InveniasDocumentTypeService);
    }

    if (namespace === Namespace.bullhorn) {
      return this.injector.get(BullhornDocumentTypeService);
    }

    if (namespace === Namespace.salesforce) {
      return this.injector.get(SalesforceDocumentTypeService);
    }

    throw new Error(`Unknown namespace '${namespace}' getting document type service.`);
  }
}
